import { useRef } from 'react';
export function useRendersCount() {
    return ++useRef(0).current;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useRendersCount.js
// module id = 5D+6
// module chunks = 0